import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import RightDrawer from '../../../components/customElements/RightDrawer/RightDrawer'
import AssignToDealerView from './RequestDetails/AssignToDealerView/AssignToDealerView'

function AssignDealerDrawer({ store, title, serviceStore }) {
  const { isAssignDealerDrawerOpen, toggleAssignDealerDrawer, selectedOrders } =
    store
  const massAssignFlag = () => {
    return (
      store.selectedOrders.size !== 0 &&
      (store.selectedOrder === null || store.selectedOrder === undefined)
    )
  }

  return (
    <RightDrawer
      open={isAssignDealerDrawerOpen}
      onClose={toggleAssignDealerDrawer}
      titleComp={
        <Box className={'fx-col'}>
          {(massAssignFlag() ? false : title) ? (
            <Typography variant={'subtitle1'} color={'common.white'}>
              {title}
            </Typography>
          ) : (
            <>
              <Typography variant={'subtitle1'} color={'common.white'}>
                <FormattedMessage id={'Заявок выбрано'} />:{' '}
                {selectedOrders.size}
              </Typography>
              <Typography variant={'body1'} color={'#8FBFF6'}>
                <FormattedMessage id={'Назначение на дилера'} />
              </Typography>
            </>
          )}
        </Box>
      }
    >
      <AssignToDealerView
        serviceStore={serviceStore}
        store={store}
        massAssign={massAssignFlag()}
      />
    </RightDrawer>
  )
}

export default observer(AssignDealerDrawer)
